const setVhValue = () => {
    // get the viewport height and multiply it by 1% to get a value for a vh unit
    const setVh = () => document.documentElement.style.setProperty('--vh-px', `${window.innerHeight * 0.01}px`);
    setVh();
    window.addEventListener('resize', () => {
        setVh();
    });
};
window.addEventListener('load', setVhValue);

export { setVhValue };
